/**
 * @fileoverview CommonConst const
 */
'use strict';
const CommonConst = {
  /**
   * コンポーネント定義:
   * コンポーネント名:
   * <ul>
   * <li>URL
   * <li>PATH
   * </ul>
   * @name COMPONENT
   * @constant
   * @memberOf const.CommonConst
   */
  COMPONENT: {
    //マイページ編集
    ACCOUNT: {
      NAME: 'ACCOUNT',
      URL: '#account',
      PATH: 'content/account/AccountEdit'
    },
    //ログイン
    LOGIN: {
      NAME: 'LOGIN',
      URL: '#auth/login',
      PATH: 'content/auth/Login'
    },
    //ログアウト
    LOGOUT: {
      NAME: 'LOGIN',
      URL: '#/Auth/logout',
      PATH: 'content/auth/Logout'
    },
    //入荷一覧
    PACKAGE_LIST: {
      NAME: 'PACKAGE_LIST',
      URL: '#package/list',
      PATH: 'content/package/PackageList'
    },
    //入荷編集
    PACKAGE_EDIT: {
      NAME: 'PACKAGE_EDIT',
      URL: '#package/edit',
      PATH: 'content/package/PackageEdit'
    },
    //入荷一覧登録（CSV）
    PACKAGE_CSV: {
      NAME: 'PACKAGE_CSV',
      URL: '#package/csv',
      PATH: 'content/package/PackageCsv'
    },
    //発券一覧
    TICKET_LIST: {
      NAME: 'TICKET_LIST',
      URL: '#ticket/list',
      PATH: 'content/ticket/TicketList'
    },
    //発券一覧
    TICKET_EDIT: {
      NAME: 'TICKET_EDIT',
      URL: '#ticket/edit',
      PATH: 'content/ticket/TicketEdit'
    },
    //入構車両一覧
    ENTRYCAR_LIST: {
      NAME: 'ENTRYCAR_LIST',
      URL: '#entrycar/list',
      PATH: 'content/entryCar/EntryCarList'
    },
    //入構車両一覧
    ENTRYCAR_EDIT: {
      NAME: 'ENTRYCAR_EDIT',
      URL: '#entrycar/edit',
      PATH: 'content/entryCar/EntryCarEdit'
    },
    //車両一覧
    CAR_LIST: {
      NAME: 'CAR_LIST',
      URL: '#car/list',
      PATH: 'content/car/CarList'
    },
    //車両登録
    CAR_REGIST: {
      NAME: 'CAR_REGIST',
      URL: '#car/regist',
      PATH: 'content/car/CarRegist'
    },
    //車両登録
    CAR_REGIST_CSV: {
      NAME: 'CAR_REGIST_CSV',
      URL: '#car/regist/csv',
      PATH: 'content/car/CarCSVRegist'
    },
    //車両編集
    CAR_EDIT: {
      NAME: 'CAR_EDIT',
      URL: '#car/edit',
      PATH: 'content/car/CarEdit'
    },
    //実績一覧
    RESULT_LIST: {
      NAME: 'RESULT_LIST',
      URL: '#result/list',
      PATH: 'content/result/ResultList'
    },
    //実績編集
    RESULT_EDIT: {
      NAME: 'RESULT_EDIT',
      URL: '#result/edit',
      PATH: 'content/result/ResultEdit'
    },
    //実績CSV出力一覧
    RESULT_OUTPUT_LIST: {
      NAME: 'RESULT_OUTPUT_LIST',
      URL: '#result/csv/list',
      PATH: 'content/result/ResultOutPutList'
    },
    //実績出力編集
    RESULT_OUTPUT_EDIT: {
      NAME: 'RESULT_OUTPUT_EDIT',
      URL: '#result/csv/output/edit',
      PATH: 'content/result/ResultCSVEdit'
    },
    //ドライバー一覧
    DRIVER_LIST: {
      NAME: 'DRIVER_LIST',
      URL: '#driver/list',
      PATH: 'content/driver/DrivertList'
    },
    //ドライバー編集
    DRIVER_EDIT: {
      NAME: 'DRIVER_EDIT',
      URL: '#driver/edit',
      PATH: 'content/driver/DrivertEdit'
    },
    //計量データ配信一覧
    MEASURE_LIST: {
      NAME: 'MEASURE_LIST',
      URL: '#measure/list',
      PATH: 'content/measure/MeasureList'
    },
    MESSAGE: {
      NAME: 'MESSAGE',
      URL: '#application/other/message',
      PATH: 'content/application/other/Message'
    },
    //テスト画面
    TEST: {
      NAME: 'TEST',
      URL: '#layoutTest/test',
      PATH: 'content/layoutTest/Test'
    }
  },

  /**
   * ログレベル：
   * <ul>
   * <li>verbose
   * <li>debug
   * <li>info
   * <li>warning
   * <li>error
   * </ul>
   * @name LOG_LEVEL
   * @constant
   * @memberOf const.CommonConst
   */
  LOG_LEVEL: {
    verbose: 0,
    debug: 1,
    info: 2,
    warning: 3,
    error: 4
  },

  /**
   * ログレベルKey：
   * <ul>
   * <li>verbose
   * <li>debug
   * <li>info
   * <li>warning
   * <li>error
   * </ul>
   * @name LOG_LEVEL_KEY
   * @constant
   * @memberOf const.CommonConst
   */
  LOG_LEVEL_KEY: ['verbose', 'debug', 'info', 'warning', 'error'],

  /**
   * ログの最大保存件数
   * @name LOG_RECORD_MAX_COUNT
   * @constant
   * @memberOf const.CommonConst
   */
  LOG_RECORD_MAX_COUNT: 1000,

  /**
   * ストレージKey：
   * <ul>
   * <li>ログ
   * <li>権限ID
   * </ul>
   * @name STORAGE_KEY
   * @constant
   * @memberOf const.CommonConst
   */
  STORAGE_KEY: {
    LOG: 'log',
    AUTHORITY_ID: 'authorityId',
    TOKEN: 'token',
    SETTING_MEMORY: 'settingMemory',
    ACCOUNT_ID: 'accountId',

    PACKAGE_CARRIER_NAME: 'package_carrierName',
    PACKAGE_EMITTER_NAME: 'package_emitterName',
    PACKAGE_STATUS: 'package_status',
    PACKAGE_PACKAGE: 'package_package',
    PACKAGE_PACKAGE_TEXT: 'package_package_text',
    PACKAGE_RECEIVE_PLACE: 'package_receivePlace',
    PACKAGE_RECEIVE_PLACE_TEXT: 'package_receivePlace_text',
    PACKAGE_CARRIER_SORT: 'package_carrierSort',
    PACKAGE_EMITTER_SORT: 'package_emitterSort',

    ENTRYCAR_START_DATE: 'entry_startDate',
    ENTRYCAR_ENT_DATE: 'entry_endDate',
    ENTRYCAR_TICKET: 'entry_ticket',
    ENTRYCAR_CARRIER_NAME: 'entry_carrierName',
    ENTRYCAR_TO: 'entry_to',

    RESULT_START_DATE: 'result_startDate',
    RESULT_END_DATE: 'result_endDate',
    RESULT_TICKET: 'result_ticket',
    RESULT_CARRIER: 'result_carrier',
    RESULT_IS_ZERO: 'reault_is_zero',
    RESULT_STATUS: 'result_status',
    RESULT_IS_EDIT: 'result_is_edit',

    MEASURE_CARRIER: 'measure_carrier',
    MEASURE_EMITTER: 'measure_emitter',
    MEASURE_START_DATE: 'mrasure_starDate',

    CAR_PLATE_NUM: 'car_plate_num',
    CAR_CARRIER: 'car_carrier'
  },

  /**
   * テーマ
   * @name THEME
   * @constant
   * @memberOf const.CommonConst
   */
  THEME: 'material',

  /**
   * タイムアウト時間
   * <ul>
   * <li>デフォルト
   * </ul>
   * @name TIMEOUT
   * @constant
   * @memberOf const.CommonConst
   */
  TIMEOUT: {
    DEFAULT: 30000
  },

  /**
   * REST API一覧
   * @name API_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  API_LIST: {
    /** マイページ編集 */
    myPageEdit: {
      URI: '/Account/{Id}',
      METHOD: 'PUT'
    },
    /** ログイン */
    login: {
      URI: '/Auth/login',
      METHOD: 'POST'
    },
    /** ログアウト */
    logout: {
      URI: '/Auth/logout',
      METHOD: 'POST'
    },
    /** 車両登録CSV */
    carRegistCsv: {
      URI: '/Car/csv',
      METHOD: 'POST'
    },
    /** 車両一覧CSV */
    carListCsv: {
      URI: '/Car/csv',
      METHOD: 'GET'
    },
    /** 車両選択一覧 */
    carSelectList: {
      URI: '/Car/select',
      METHOD: 'GET',
      LIST_RESPONSE_KEY: 'car_select_list'
    },
    /** 入荷一覧 */
    packageList: {
      URI: '/Booking/package',
      METHOD: 'GET',
      LIST_RESPONSE_KEY: 'booking_list'
    },
    /** 入荷詳細 */
    packageDetail: {
      URI: '/Booking/Detail',
      METHOD: 'GET'
    },
    /** 入荷情報変更 */
    packageEdit: {
      URI: '/Booking/Update',
      METHOD: 'PUT'
    },
    /** 入荷一覧出力 */
    packageCav: {
      URI: '/Booking/csv',
      METHOD: 'GET'
    },
    /** 入荷予定登録CSV */
    packageRegistCsv: {
      URI: '/Booking/csv',
      METHOD: 'POST'
    },
    /** 車両一括登録CSV */
    carCsv: {
      URI: '/Car/csv',
      METHOD: 'POST'
    },
    /** ステータス取得 */
    packageStatus: {
      URI: '/Booking/Status',
      METHOD: 'GET',
      LIST_RESPONSE_KEY: 'status_list'
    },
    /** 荷姿取得 */
    packageHolly: {
      URI: '/Booking/Holly',
      METHOD: 'GET',
      LIST_RESPONSE_KEY: 'holly_list'
    },
    /** 受け入れ場所取得 */
    packageAccept: {
      URI: '/Booking/Accept',
      METHOD: 'GET',
      LIST_RESPONSE_KEY: 'accept_list'
    },
    /** 入構済み車両一覧 */
    entryCarList: {
      URI: '/EntryCar/entryCar',
      METHOD: 'GET',
      LIST_RESPONSE_KEY: 'entry_car_list'
    },
    /** 入構済み車両詳細 */
    entryCarDetail: {
      URI: '/EntryCar/Detail/{id}',
      METHOD: 'GET'
    },
    /** 入構済車両変更 */
    entryCarEdit: {
      URI: '/EntryCar/Update',
      METHOD: 'PUT'
    },
    /** 入構車両出力 */
    entryCarCav: {
      URI: '/EntryCar/csv',
      METHOD: 'GET'
    },
    /** 実績一覧 */
    resultList: {
      URI: '/Result/result',
      METHOD: 'GET',
      LIST_RESPONSE_KEY: 'result_list'
    },
    /** 実績詳細 */
    resultDetail: {
      URI: '/Result/Detail',
      METHOD: 'GET'
    },
    /** 実績変更 */
    resultEdit: {
      URI: '/Result/Update/{performance_id}/{performance_id_detail}',
      METHOD: 'PUT'
    },
    /** 実績出力 */
    resultCav: {
      URI: '/Result/csv',
      METHOD: 'GET'
    },
    /** 実績工場側出力 */
    resultFactoryCav: {
      URI: '/Result/csv/factory',
      METHOD: 'GET'
    },
    /** 実績物流側出力 */
    resultLogisticsCav: {
      URI: '/Result/csv/logistics',
      METHOD: 'GET'
    },
    /** 実績削除 */
    resultDelete: {
      URI: '/Result/Delete',
      METHOD: 'DELETE'
    },
    /** 実績CSVOutPut一覧取得 */
    resultCSVOutPutList: {
      URI: '/Result/CSV/List',
      METHOD: 'GET',
      LIST_RESPONSE_KEY: 'csv_list'
    },
    /** 実績CSVOutPut取得(CSV出力ボタン押下時処理) */
    resultCSVOutPutListCsv: {
      URI: '/Result/CSV/Csv',
      METHOD: 'GET'
    },
    /** 実績CSVOutPut詳細 */
    resultCSVOutPutDetail: {
      URI: '/Result/CSV/Detail/{id}',
      METHOD: 'GET'
    },
    /** 実績CSVOutPut編集 */
    resultCSVOutPutUpdate: {
      URI: '/Result/CSV/Update/{id}',
      METHOD: 'PUT'
    },
    /** 計量データ配信一覧 */
    measureList: {
      URI: '/Measure/reception',
      METHOD: 'GET',
      LIST_RESPONSE_KEY: 'measure_list'
    },
    /** 計量データ配信一覧PDF出力 */
    measurePdf: {
      URI: '/Measure/pdf',
      METHOD: 'GET'
    },
    /** 車両一覧 */
    carList: {
      URI: '/Car',
      METHOD: 'GET',
      LIST_RESPONSE_KEY: 'car_list'
    },
    /** 車両詳細 */
    carDetail: {
      URI: '/Car/{id}',
      METHOD: 'GET'
    },
    /** 車両編集 */
    carEdit: {
      URI: '/Car/{id}',
      METHOD: 'PUT'
    },
    /** 車両登録 */
    carRegist: {
      URI: '/Car',
      METHOD: 'POST'
    },
    /** 車両削除 */
    carDelete: {
      URI: '/Car',
      METHOD: 'DELETE'
    },
    /** 車両QRコード出力 */
    carQr: {
      URI: '/Car/Qr/{id}',
      METHOD: 'GET'
    },
    /** ファイルアップロード情報取得*/
    upload: {
      URI: '/Upload/url',
      METHOD: 'GET'
    }
  },

  /**
   * HTTPステータスコードリスト
   * <ul>
   * <li>401
   * </ul>
   * @name HTTP_STATUS_CODE_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  HTTP_STATUS_CODE_LIST: {
    CONNECTION_ERROR: 0,
    BAR_REQUEST: 400,
    UNAUTHORIZED: 401
  },

  /**
   * リクエストタイプリスト
   * @name REQUEST_TYPE_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  REQUEST_TYPE_LIST: {
    GET: 'GET',
    PUT: 'PUT',
    POST: 'POST',
    DELETE: 'DELETE'
  },

  /**
   * 曜日リスト
   * <ul>
   * <li>月
   * <li>火
   * <li>水
   * <li>木
   * <li>金
   * <li>土
   * <li>日
   * </ul>
   * @name WEEK_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  WEEK_LIST: ['1', '2', '3', '4', '5', '6', '0'],

  /**
   * 入力値の最大文字数リスト
   * <ul>
   * <li>50
   * </ul>
   * @name INPUT_MAX_LENGTH_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  INPUT_MAX_LENGTH_LIST: {
    MAX_1: 1,
    MAX_2: 2,
    MAX_3: 3,
    MAX_4: 4,
    MAX_5: 5,
    MAX_7: 7,
    MAX_8: 8,
    MAX_11: 11,
    MAX_12: 12,
    MAX_16: 16,
    MAX_30: 30,
    MAX_32: 32,
    MAX_50: 50,
    MAX_255: 255,
    MAX_256: 256,
    MAX_512: 512
  },

  /**
   * 権限リスト
   * @name  AUTHORITY_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  AUTHORITY_LIST: {},

  /**
   * 実績csv編集描画に用いるリスト
   * @name  MEASURE_TYPE_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  MEASURE_TYPE_LIST: {
    DISPOSAL: '処分場計量値',
    CLIENT: '顧客計量値',
    ITEM: '荷姿換算値'
  },

  /**
   * 集計種類リスト
   * @name  TOTALCATEGORY_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  TOTALCATEGORY_LIST: {
    /** 日報 */
    DATE: '1',
    /** 月報 */
    MONTH: '2'
  },
  /**
   * 正規表現パターン
   * @name REGULAR_EXPRESSION_PATTERN
   * @constant
   * @memberOf const.CommonConst
   */
  REGULAR_EXPRESSION_PATTERN: {
    /** 半角英数字 */
    P001: /^[a-zA-Z0-9]*$/,
    /** true or false */
    P002: /true|false/,
    /** 半角数字(整数) */
    P003: /^\d*$/,
    /** 半角英数記号 */
    P004: /^[\x20-\x7e]*$/,
    /** メールアドレス */
    P005: /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]*@[a-zA-Z0-9-]*(?:\.[a-zA-Z0-9-]*)*$/,
    /** 全角 */
    P007: /^[^ -~｡-ﾟ]*$/,
    /** 分類番号 */
    P008: /^[A-Z0-9]*$/,
    /** 用途コード */
    P009: /^[\u3040-\u3048\u304B-\u3056\u3058-\u3077\u3079-\u308F\u3094-\u309f\u3092A-Z]*$/,
    /** URI置換 */
    P010: /\{.+\}/,
    /** パスワードポリシー */
    P011: /^(?=.*?[a-zA-Z])(?=.*?\d)[a-zA-Z\d]{8,32}$/,
    /** ユーザーID */
    P012: /^[a-zA-Z0-9]{6,256}$/,
    /** 半角数字 4桁 */
    P013: /^[0-9]{0,4}$/,
    /** 半角数字 16桁 */
    P014: /^[0-9]{0,16}$/,
    /** ひらがな  */
    P015: /^[ぁ-ゞー]+$/,
    /** WCN 半角数字 9桁 */
    P016: /^[0-9]{0,9}$/,
    /** 日時 */
    P017: /^[0-9]{4}\/[0-9]{2}\/[0-9]{2} [0-9]{2}:[0-9]{2}$/
  },

  /**
   * changeValueValidate用正規表現パターン
   * changeValueValidateにて文字列操作を行うため、stringで定義
   * @name VALIDATE_REGEXP_PATTERN
   * @constant
   * @memberOf const.CommonConst
   */
  VALIDATE_REGEXP_PATTERN: {
    HALF_ALPHA_LOWER: 'a-z',
    HALF_ALPHA_UPPER: 'A-Z',
    HALF_NUMERIC: '0-9',
    HALF_ALPHA: 'a-zA-Z',
    HALF_ALPHA_LOWER_NUMERIC: 'a-z0-9',
    HALF_ALPHA_UPPER_NUMERIC: 'A-Z0-9',
    HALF_ALPHA_NUMERIC: 'a-zA-Z0-9',
    HALF_NUM: '0.0-9.9',
    HALF_NUM_FOR_TICKET_NUM: '0-9-'
  },

  /**
   * 一覧画面テーブル最大行数
   * @name LIST_TABLE_MAX_ROW
   * @constant
   * @memberOf const.CommonConst
   */
  LIST_TABLE_MAX_ROW: 10,

  /**
   * ファイル拡張子
   * @name FILE_NAME_EXTENSION
   * @constant
   * @memberOf const.CommonConst
   */
  FILE_NAME_EXTENSION: {
    CSV: 'csv',
    TSV: 'tsv'
  },

  /**
   * リクエストヘッダーキー
   * @name REQUEST_HEADER_KEYS
   * @constant
   * @memberOf const.CommonConst
   */
  REQUEST_HEADER_KEYS: {
    X_LOGIPULL_TOKEN: 'X-LogiPullToken'
  },

  /**
   * キーボードイベントのキーコード
   * @name KEYBOARD_EVENT_KEY_CODE
   * @constant
   * @memberOf const.CommonConst
   */
  KEYBOARD_EVENT_KEY_CODE: {
    ENTER_KEY: 13
  },

  /**
   * クエリパラメータのキーリスト
   * @name QUERY_PARAMETER_KEY_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  QUERY_PARAMETER_KEY_LIST: {
    QUESTION_MARK: '?',
    EQUAL: '=',
    AND: '&',
    PERIOD: '.',
    ID: 'id',
    PERFORMANCE_DETAIL_ID: 'performance_detail_id',
    MODE: 'mode',
    MESSAGE: 'msg',
    MAIN: 'main',
    TITLE: 'title',
    SUB: 'sub',
    BUTTON: 'button',
    ENTRY_DATE: 'entryDate',
    WORKSPACE_ID: 'workspaceId',
    WORKSPACE: 'workspace'
  },

  /**
   * APIのキーリスト
   * @name API_REPLACE_KEY
   * @constant
   * @memberOf const.CommonConst
   */
  API_REPLACE_KEY: {
    ID: '{id}'
  },

  /**
   * エラーエリアのスタイル
   * @name ERROR_AREA_STYLE
   * @constant
   * @memberOf const.CommonConst
   */
  ERROR_AREA_STYLE: {
    SUCCESS: 'success',
    INFO: 'info',
    WARNING: 'warning',
    DANGER: 'danger'
  },

  /**
   * 設定情報キーリスト
   * @name SETTING_MEMORY_KEY_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  SETTING_MEMORY_KEY_LIST: {
    CAR_NO: 'carNo',
    COMPANY_NAME: 'companyName',
    ENTRY_DATE_FROM: 'entryDateFrom',
    ENTRY_DATE_TO: 'enrtyDateTo',
    WORKSPACE: 'workspace',
    STAY_STATUS_IDS: 'stayStatusIds',
    WORK_KIND_ID: 'workKindId',
    WORK_KIND: 'workKind',
    IS_AVAILABLE: 'isAvailable',
    TOTALCATEGORY: 'totalcategory',
    DATE: 'date',
    MONTH: 'month',
    AVAILABILITY: 'availability',
    CALENDERSTYLE: 'calenderstyle',
    ACCEPT_ID: 'acceptId'
  },

  /**
   * 設定情報初期値
   * @name SETTING_MEMORY_DEFAULT
   * @constant
   * @memberOf const.CommonConst
   */
  SETTING_MEMORY_DEFAULT: {
    CAR_LIST: {
      carNo: '',
      companyName: ''
    },
    WORKSPACE_LIST: {
      workspace: '',
      availability: ''
    },
    SERVICE_HISTORY_LIST: {
      entryDateFrom: '',
      enrtyDateTo: '',
      workSpace: '',
      stayStatusIds: '',
      workKindId: '',
      workKind: '',
      isAvailable: ''
    },
    TOTAL_WORKSPACE: {
      totalcategory: '',
      date: '',
      month: '',
      calenderstyle: ''
    },
    TOTAL_MESUREMENT: {
      totalcategory: '',
      date: '',
      month: '',
      calenderstyle: ''
    },
    TOTAL_CAR: {
      totalcategory: '',
      date: '',
      month: '',
      calenderstyle: ''
    },
    WORKSPACE_SCHEDULE_LIST: {
      entryDateFrom: '',
      stayStatusIds: '',
      workspace: '',
      workspaceId: ''
    }
  },

  /**
   * ファイルの合計最大サイズ(byte)
   * @name FILE_TOTAL_MAX_SIZE
   * @constant
   * @memberOf const.CommonConst
   */
  FILE_TOTAL_MAX_SIZE: 5242880,

  /**
   * リザルトコードリスト
   * @name RESULT_CODE_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  RESULT_CODE_LIST: {
    REQUEST_ERROR: 9,
    NOT_EXIST_ANTENNA: 101,
    NOT_EXIST_AREA: 102,
    NOT_EXIST_CAR: 103,
    NOT_EXIST_FA2: 104,
    NOT_EXIST_GATE: 105,
    NOT_EXIST_STAYSTATUS: 106,
    NOT_EXIST_TRUCKSCALE: 107,
    NOT_EXIST_WORKSPACE: 108,
    NOT_EXIST_WORKKIND: 109,
    NOT_EXIST_SERVICEHISTORY: 111,
    NOT_EXIST_TRUCKSCALESTATUS: 112,
    NOT_EXIST_WORKSPACESCHEDULE: 113,
    EXIST_wcn: 114,
    EXIST_CARNO: 115,
    EXIST_SERVICEHISTORY: 116,
    NOT_EXIST_ACCOUNT: 117,
    MISMATCH_PASSWORD: 119,
    MISMATCH_ACCOUNT: 120,
    EXIST_WORKSPACECODE: 121,
    CONSISTENT_STAYSTATUS_WAIT: 122,
    CONSISTENT_STAYSTATUS_FINISH: 123,
    CREATEERROR_PDF: 124,
    MISMATCH_STAYSTATUS: 125,
    CANT_DELETE_WORKSPACE: 126,
    NOT_EXIST_DEDAIL: 128,
    NO_EXIT_DATA: 99
  },

  /**
   * moment.js 日付単位キー
   * @name MOMENT_KEYS
   * @constant
   * @memberOf const.CommonConst
   */
  MOMENT_KEYS: {
    YEARS: 'y',
    MONTHS: 'M',
    DAYS: 'd',
    HOUR: 'h',
    MINUTES: 'm'
  },

  /**
   * ステータスリスト
   * @name STAY_STATUSES_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  STAY_STATUSES_LIST: {
    STAND_BY: '1',
    WORKING: '2',
    COMPLETE: '3',
    RE_ENTRY: '4'
  },
  /**
   * 作業種別
   * @name WORK_KINDS_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  WORK_KINDS_LIST: {
    LOADING: '1',
    UNLOADING: '2'
  },
  /**
   * 利用状態リスト
   * @name AVAILABLE_LIST
   * @constant
   * @memberOf const.CommonConst
   */
  AVAILABLE_LIST: [
    {},
    { value: true, text: '有効' },
    { value: false, text: '無効' }
  ],
  /**
   * 作業種別
   * @name WORK_KINDS
   * @constant
   * @memberOf const.CommonConst
   */
  WORK_KINDS: [
    { id: 1, name: '積込み' },
    { id: 2, name: '積降し' }
  ],

  /**
   * 作業種別(SelectItem用)
   * @name WORK_KINDS_SELECT_ITEM
   * @constant
   * @memberOf const.CommonConst
   */
  WORK_KINDS_SELECT_ITEM: [
    {},
    { value: '1', text: '積込み' },
    { value: '2', text: '積降し' }
  ],

  /**
   * 有効状態
   * @name AVAILABILITY
   * @constant
   * @memberOf const.CommonConst
   */
  AVAILABILITY: [
    { id: 1, name: '有効' },
    { id: 2, name: '無効' }
  ],

  /**
   * 有効状態(SelectItem用)
   * @name AVAILABILITY_SELECT_ITEM
   * @constant
   * @memberOf const.CommonConst
   */
  AVAILABILITY_SELECT_ITEM: [
    {},
    { value: true, text: '有効' },
    { value: false, text: '無効' }
  ],

  /**
   * 現場
   * @name WORKSPACE
   * @constant
   * @memberOf const.CommonConst
   */
  WORKSPACE: [
    { id: 1, name: '積込' },
    { id: 2, name: '石灰' },
    { id: 3, name: '不明' }
  ],

  /**
   * 入荷検索チェックボックス
   * @name PACKAGE_CHECKBOX
   * @constant
   * @memberOf const.CommonConst
   */
  PACKAGE_CHECKBOX: [
    {
      id: 1,
      name: '荷姿'
    },
    {
      id: 2,
      name: '数量'
    },
    {
      id: 3,
      name: '単位'
    },
    {
      id: 4,
      name: '重量'
    },
    {
      id: 5,
      name: '受入場所'
    },
    {
      id: 6,
      name: '受入判定特記事項'
    }
  ],

  /**
   * 入荷状態
   * @name AVAILABILITY_STETUS
   * @constant
   * @memberOf const.CommonConst
   */
  AVAILABILITY_STETUS: [
    { value: 1, text: '' },
    { value: 2, text: '入荷' },
    { value: 3, text: '未入荷' }
  ],

  /**
   * contentの最小高さの補正値
   */
  CONTENT_HEIGHT_ADJUST: 30
};

export default CommonConst;



// WEBPACK FOOTER //
// ./src/js/const/CommonConst.jsx